import React from 'react';
import Pagination from 'react-js-pagination';
import { IBox, Title, Content, Icon, Row, Column, Search, Button } from '../../inspinia';
import { DEFAULT_PAGE_RANGE, MESSAGE_ERROR, AUTH_ERROR, AUTH_HEADER, API_BASE_URL } from '../../../helpers/constants';

import './style.css';
import { getToken, isAuthenticated } from '../../../store/auth';
import withReactContent from 'sweetalert2-react-content';
import Swal from 'sweetalert2';

export default class ListaTemplate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            obj: [],
            page: 0,
            list:
            {
                currentPage: 0, pageCount: 0, pageSize: 0, rowCount: 0, results: undefined
            },
            filter: '',
            selfMain: this.props.history,
            recarregar: this.props.recarregar,
            alerta: withReactContent(Swal)
        }
        
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleBuscarInput = this.handleBuscarInput.bind(this);
        this.handleBuscarClick = this.handleBuscarClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.state.list.results || this.state.recarregar || prevProps.templates !== this.props.templates ) {
            this.state.recarregar = false;
            this.loadListaTemplates(this.state.page);
        }
    }

    loadListaTemplates(pageNumber, filterParam) {
        let listaTemplates = this.props.templates;

        if (filterParam) {
            listaTemplates = listaTemplates.filter(t => t.nome.toUpperCase().includes(filterParam.toUpperCase()));
        }

        let page = pageNumber === undefined || pageNumber === 0 ? 0 : pageNumber - 1;
        let limit = 10;
        let slice1 = page * limit;
        let slice2 = limit * (page + 1);

        this.setState({
            ...this.state,
            list: {
                ...this.state.list,
                results: listaTemplates.slice(slice1, slice2),
                pageSize: limit,
                rowCount: listaTemplates.length,
                currentPage: this.state.page
            }
        });


    }

    handlePageChange(pageNumber) {
        this.state.page = pageNumber;
        this.loadListaTemplates(pageNumber, this.state.filter);
    }

    handleBuscarClick() {
        this.setState({ ...this.state, page: 1 });
        this.loadListaTemplates(1, this.state.filter);
    }

    handleBuscarInput(e) {
        this.setState({ ...this.state, filter: e.target.value });
    }

    render() {
        let html = "";

        if (this.state.list.results === undefined) {
            html = (<div className="sk-spinner sk-spinner-three-bounce">
                <div className="sk-bounce1"></div>
                <div className="sk-bounce2"></div>
                <div className="sk-bounce3"></div>
            </div>);
        }
        else if (this.state.list.results.length === 0) {
            html = (<li>Nenhum registro encontrado.</li>);
        }
        else if (this.state.list.results.length > 0) {
            html = this.state.list.results.map((template, index) =>
                <li className="itemListaTemplates" id={template.id} key={template.id}>
                    <div>
                        <span>{template.campanha.descricao}</span>
                    </div>
                    <div>
                        <div className="text-center">
                            <a onClick={this.props.onClick.bind(this, this.props.status, template.id)}>
                                <Icon name="fa-edit" className="mx-1 text-info" />
                            </a>
                        </div>
                    </div>
                </li>
            );
        }
        return (
            <div>
                {/* MAIN CONTENT */}
                <Row className="mb-4">
                    <Column>
                        <IBox>
                            <Title>
                                <h3 className="text-slate-grey">Templates</h3>
                            </Title>

                            <Content>
                                {/* TABELA */}
                                <Row className="m-0 mb-0">
                                    <Column className="p-0 table-responsive">
                                        <ul className="listaTemplates">{html}</ul>
                                    </Column>
                                </Row>
                            </Content>
                        </IBox>
                    </Column>
                </Row>

                {/* FOOTER */}
                <Row className="mb-5">
                    <Column className="container">
                        <Row>
                            <Column size="12" className="text-center">
                                <div className="d-flex justify-content-center">

                                    <Pagination
                                        hideNavigation
                                        pageRangeDisplayed={DEFAULT_PAGE_RANGE}
                                        activePage={this.state.page}
                                        itemsCountPerPage={this.state.list.pageSize}
                                        totalItemsCount={this.state.list.rowCount}
                                        onChange={this.handlePageChange}
                                    />

                                </div>
                            </Column>
                        </Row>
                    </Column>
                </Row>
            </div>
        )
    }
}
